import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import LocaleKeys from '../../locales/keys';
import { getFreeTrialImage } from '../../utils/common';

const useStyles = makeStyles(() => ({
  freeTrialImage: {
    marginBottom: '25px',
    marginTop: '10px',
    maxWidth: '250px',
  },
  freeTrialCopy: {
    fontSize: '17px',
    fontFamily: 'TitilliumWeb-Regular',
    letterSpacing: '0.2px',
    marginBottom: '20px',
  },
}));

const FreeTrialHeader = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  const image = getFreeTrialImage();

  return (
    <Box className="ascendon-order-summary">
      <img
        className={classes.freeTrialImage}
        src={image}
        alt={t(LocaleKeys.freeTrial.altText)}
      ></img>
      <Typography className={classes.freeTrialCopy}>
        {t(LocaleKeys.freeTrial.information)}
      </Typography>
    </Box>
  );
};

export default FreeTrialHeader;
